import React, { useEffect } from "react";
import ProductShowcase from "../../components/cultivars/SleepyJoeOg/ProductShowcase";
import Footer from "../../components/Footer";
import Cta from "../../components/Cta";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import Navbar from "../../components/Navbar";
import { Helmet } from "react-helmet";

const SleepyJoeOG = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
    <Helmet>
        <title>Sleepy Joe OG Strain - Ultimate Nighttime Relaxation | BeyondBloom™</title>
        <meta
          name="description"
          content="Sleepy Joe OG is the perfect strain for deep relaxation and restful sleep, making it ideal for nighttime use."
        />
        <meta
          name="keywords"
          content="Sleepy Joe OG strain, nighttime cannabis, relaxing weed, deep sleep marijuana, BeyondBloom"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta property="og:title" content="Sleepy Joe OG Strain - Ultimate Nighttime Relaxation | BeyondBloom™" />
        <meta
          property="og:description"
          content="Sleepy Joe OG is the perfect strain for deep relaxation and restful sleep, making it ideal for nighttime use."
        />
        <meta property="og:image" content="/images/sleepy-joe-og.png" />
        <meta property="og:url" content="https://yourwebsite.com/cultivars/sleepy-joe-og" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Sleepy Joe OG Strain - Ultimate Nighttime Relaxation | BeyondBloom™" />
        <meta
          name="twitter:description"
          content="Sleepy Joe OG is the perfect strain for deep relaxation and restful sleep, making it ideal for nighttime use."
        />
        <meta name="twitter:image" content="/images/sleepy-joe-og.png" />
      </Helmet>
      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default SleepyJoeOG;
